import React from 'react'
import { Image } from 'antd-mobile-v5'
import { useHistory } from 'react-router-dom'

import styles from './CertShow.module.css'
import { finalImagePath } from '../../services/utilities'

// WZZ dsd has its own style, hide ecard name
const hideEcardName = (ecard) => !ecard || (ecard.certificationNumber === 58 && ecard.storeNumber === 23724)

const MainlandCertShow = ({ path, cert, isLocked, cardImageName, currentYearImage, yearImage }) => {
  const { push } = useHistory()
  const cardName = cert.cardTextDTOS || cert.certificationName || cert.credentialName

  const toBuyCards = () => {
    if (yearImage && currentYearImage) return push('/newYearCampaignPost')
    push('/buy_cards', { ecardId: cert.encodedId, cardImageName })
  }

  return (
    <div className={styles['card-wrapper']}>
      {isLocked && (
        <div className={styles['lock-layer']} onClick={toBuyCards}>
          <img src={require('../../assets/images/buy_cards/lock-icon.png')} alt="lock" className={styles.lock} />
          <div className={styles.text}>您暂未获得该卡，点击解锁该卡面</div>
        </div>
      )}
      {!hideEcardName(cert) && (
        <div className={styles['cert-name']}>
          {cardName instanceof Array ? (
            cardName.map((item) => <div key={item.cardTextLine}>{item.cardTextLine}</div>)
          ) : (
            <div>{cardName}</div>
          )}
        </div>
      )}
      <div className={styles['card-img-bg']}>
        <Image fit="contain" src={finalImagePath(cert, path)} lazy className={styles['card-img']} />
      </div>
    </div>
  )
}

export default MainlandCertShow
